import { gearGrade } from '../config/config';

const tiers = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const getSaleId = (roundId, grade) => {
  const gradeNums = {};
  gradeNums[gearGrade.rare] = 10;
  gradeNums[gearGrade.elite] = 100;

  if (gradeNums[grade] && roundId && roundId > 0 && roundId < tiers.length) {
    return `t${tiers[roundId]}g${gradeNums[grade]}`;
  }

  return undefined;
};
